<template>
  <div>
    <el-row v-for="item in dataList"
            :key="item.id">
      <el-col class="row-title"
              :span="18">
        <router-link :to="{ path: '/notice/article/', query: { id: item.id } }">
          {{ item.title }}
        </router-link>
      </el-col>
      <el-col :span="6"
              class="row-time">{{ item.time }}</el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataList: [
        {
          title: '美团地图开发者合规指南',
          time: '2021年08月17日',
          id: 10
        }
      ]
    };
  }
};
</script>

<style scoped lang='less'>
.el-row {
  height: 46px;
  line-height: 46px;
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.12);
}
.row-title {
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.84);
  line-height: 24px;
  font-weight: 500;
}
.row-title:hover {
  color: #385dff;
}
.row-time {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  text-align: right;
  line-height: 24px;
  font-weight: 400;
}
</style>
